<app-file-manager-dialog-form [existingFileNames]="data?.existingFileNames" [currentTotalSize]="data?.currentTotalSize"></app-file-manager-dialog-form>
